module.exports = __webpack_public_path__ + "img/tooltip.0054f6d.svg";